export default {
  title: 'Récapitulatif des ventes',
  description:
    'Ventes pour la période sélectionnée — à utiliser pour la réconciliation de facturation avec ce restaurant.',
  filters: {
    period: 'Période',
  },
  presets: {
    this_month: 'Ce mois-ci',
    last_month: 'Le mois dernier',
    last_30_days: '30 derniers jours',
    this_year: 'Cette année',
  },
  fields: {
    orders_count: 'Commandes',
    net_sales: 'Ventes nettes',
    sales_tax: 'Taxe sur les ventes',
    gross_sales: 'Ventes brutes',
    delivery_fee_tax: 'Frais de livraison (taxe)',
    delivery_fee_gross: 'Frais de livraison (brut)',
    tips_gross: 'Pourboires (brut)',
    total: 'Total',
  },
  kpi: {
    before_tax: 'hors taxe',
    tips: 'collecté pour le restaurant',
    owed_to_restaurant: 'dû au restaurant',
  },
  table: {
    title: 'Détail',
    subtitle: '{{range}} · Tous les montants en {{currency}}',
    field: 'Champ',
    amount: 'Montant',
    empty: 'Aucune commande sur la période sélectionnée',
    footnote:
      "Les ventes nettes excluent la taxe ; les ventes brutes l'incluent · Le total est net des frais de plateforme, il ne correspond pas au montant payé par le client · Les remboursements et rétrofacturations sont déduits · Montants en {{currency}}",
  },
  buttons: {
    export_csv: 'Exporter CSV',
    refresh: 'Actualiser',
    retry: 'Réessayer',
  },
  errors: {
    failed_to_load: {
      title: 'Impossible de charger le récapitulatif des ventes',
      description: "Une erreur s'est produite lors du chargement du rapport. Veuillez réessayer.",
    },
  },
};
